import { HTMLMotionProps, motion } from "framer-motion";

const FadeIn = (props: HTMLMotionProps<"div">) => {
    const { children, ...rest } = props;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export default FadeIn;
